export function formatAnchorLinkId(id: string): string {
  // ID needs to start with a letter
  return `S${id.toLowerCase().slice(0, 6)}`;
}

/**
 * Resolves the HTML id used as a section's anchor target.
 * Prefers the editor-defined sectionUrl (Contentful) so URLs can be human-readable
 * (e.g. `#writers-challange`), and falls back to the auto-generated id
 * derived from the entry's sys.id for components that don't yet expose a sectionUrl field.
 */
export function resolveSectionId(
  sysId: string,
  sectionUrl?: string | null,
): string {
  return sectionUrl?.trim() ? sectionUrl.trim() : formatAnchorLinkId(sysId);
}
